var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_8000",
    "data-name": "\\uADF8\\uB8F9 8000",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12646",
    "data-name": "\\uD328\\uC2A4 12646",
    d: "M209.464,1683H197.536a4.536,4.536,0,0,1-4.536-4.536v-11.928a4.536,4.536,0,0,1,4.536-4.536h11.928a4.536,4.536,0,0,1,4.536,4.536v11.928a4.536,4.536,0,0,1-4.536,4.536",
    transform: "translate(-193 -1662)",
    fill: "#3495d3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12647",
    "data-name": "\\uD328\\uC2A4 12647",
    d: "M229.763,1693.809a5.074,5.074,0,0,1-1.494.445,2.77,2.77,0,0,0,1.141-1.557,4.939,4.939,0,0,1-1.644.682,2.507,2.507,0,0,0-1.894-.891,2.711,2.711,0,0,0-2.591,2.817,3.133,3.133,0,0,0,.06.642A7.165,7.165,0,0,1,218,1693a3.024,3.024,0,0,0-.355,1.424,2.892,2.892,0,0,0,1.152,2.34,2.411,2.411,0,0,1-1.171-.347v.031a2.782,2.782,0,0,0,2.077,2.767,2.4,2.4,0,0,1-.68.093,2.119,2.119,0,0,1-.491-.048,2.655,2.655,0,0,0,2.423,1.962,4.954,4.954,0,0,1-3.215,1.2,4.455,4.455,0,0,1-.62-.039,6.885,6.885,0,0,0,3.978,1.264c4.772,0,7.38-4.292,7.38-8.013,0-.125,0-.245-.009-.364a5.431,5.431,0,0,0,1.3-1.462",
    transform: "translate(-212.524 -1687.261)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.41fa4256c5806a63ce07bf135085d1d0.svg";
export { ForwardRef as ReactComponent };